import { fmtDate } from '../lib/format';
import { eurC } from '../lib/money';
import { deProzent, parseProzent, skontoBetrag, type SkontoWerte } from './formular';
import './formular.css';

// Zahlungsbedingungen (Rechnung und wiederkehrende Rechnung): Zahlungsziel in Tagen und, aufklappbar, Skonto
// („Skonto anbieten“: Prozent bei Zahlung innerhalb von Tagen ab Rechnungsdatum). Darunter, was der Kunde mit Skonto
// zahlt und bis wann.
//
// Props: tage/onTage (Zahlungsziel als Text), skonto/onSkonto (null: kein Skonto), grossCents (Rechnungsbetrag für die
// Vorschau, 0: ohne), invoiceDate (Rechnungsdatum aus dem Formular; null: ohne Datum in der Vorschau, z. B. bei
// wiederkehrenden Rechnungen), w (Währung des Betrags).
export function ZahlungBlock({
  tage,
  onTage,
  skonto,
  onSkonto,
  grossCents,
  invoiceDate,
  w = 'EUR',
}: {
  tage: string;
  onTage(v: string): void;
  skonto: SkontoWerte | null;
  onSkonto(v: SkontoWerte | null): void;
  grossCents: number;
  invoiceDate: string | null;
  w?: string;
}) {
  const ziel = /^\d+$/.test(tage.trim()) ? Number(tage) : null;
  const p = skonto ? parseProzent(skonto.prozent) : null;
  const t = skonto && /^\d+$/.test(skonto.tage.trim()) ? Number(skonto.tage) : null;
  const ok = typeof p === 'number' && p > 0 && p <= 10 && t != null && t >= 1 && t <= 60;
  const zuLang = ok && ziel != null && t! >= ziel;
  const vorschau = ok && !zuLang && grossCents > 0 ? skontoBetrag({ prozent: p!, tage: t! }, invoiceDate ?? '2000-01-01', grossCents) : null;

  function anbieten() {
    // Vorschlag: 2 % in 10 Tagen (kürzer als das Zahlungsziel)
    const tg = ziel != null && ziel <= 10 ? Math.max(1, ziel - 1) : 10;
    onSkonto({ prozent: deProzent(2), tage: String(tg) });
  }

  return (
    <div className="zb">
      <div className="rt-grid">
        <label className="field">
          <span>Zahlungsziel in Tagen</span>
          <input value={tage} inputMode="numeric" onChange={(e) => onTage(e.target.value)} />
        </label>
        {skonto ? (
          <>
            <label className="field">
              <span>Skonto in %</span>
              <input value={skonto.prozent} inputMode="decimal" onChange={(e) => onSkonto({ ...skonto, prozent: e.target.value })} />
            </label>
            <label className="field">
              <span>bei Zahlung in Tagen</span>
              <input value={skonto.tage} inputMode="numeric" onChange={(e) => onSkonto({ ...skonto, tage: e.target.value })} />
            </label>
            <div className="zb-weg">
              <button type="button" className="linkbtn" onClick={() => onSkonto(null)}>
                Kein Skonto
              </button>
            </div>
          </>
        ) : (
          <div className="zb-an">
            <button type="button" className="linkbtn" onClick={anbieten}>
              + Skonto anbieten
            </button>
          </div>
        )}
      </div>
      {skonto && (
        <p className={`zb-info${ok && !zuLang ? '' : ' bad'}`}>
          {!ok
            ? 'Bitte Skonto bis 10 % und die Frist in Tagen (1 bis 60) eintragen.'
            : zuLang
              ? 'Die Skontofrist muss kürzer sein als das Zahlungsziel.'
              : vorschau
                ? `Auf der Rechnung: Bei Zahlung ${invoiceDate ? `bis zum ${fmtDate(vorschau.bis)}` : `innerhalb von ${t} Tagen`} ziehen Sie ${deProzent(p!)} % Skonto ab: zu zahlen ${eurC(vorschau.zahlen / 100, w)}.`
                : `Bei Zahlung innerhalb von ${t} Tagen ${deProzent(p!)} % Skonto.`}
        </p>
      )}
    </div>
  );
}
